module.exports = __webpack_public_path__ + "img/06.4b1067d2.jpg";